import "./LinkStyles.scss";
import $ from "jquery";
import { track_event } from "../FunctionsCore";
const link = (linkParameter) => {
    if (linkParameter.adobeAnalyticsEnabled) {
        $(() => {
            window.document.querySelectorAll(".link a").forEach((el) => {
                if (el instanceof HTMLElement) {
                    el.addEventListener("click", () => track_event(`${el.textContent} button clicked`));
                }
            });
        });
    }
};
export { link };
